import { withTranslation } from "next-i18next";
import MenuListButton from "@components/core/MenuListButton";
import { useDislikeProduct } from "@hooks/use-current-user";
import { useOpenAddToUserListOffcanvas } from "@hooks/use-userlists";

function MenuWishlistProductEdit({ product, onActionEnd, t }) {
  const dislikeProduct = useDislikeProduct();
  const openAddToUserListOffcanvas = useOpenAddToUserListOffcanvas();

  function openAddToUserListOffcanvasAndClose() {
    openAddToUserListOffcanvas(product);
    onActionEnd();
  }

  function dislikeAndClose() {
    dislikeProduct(product.id);
    onActionEnd();
  }

  return (
    <div className="d-flex flex-column w-100">
      <MenuListButton
        onClick={openAddToUserListOffcanvasAndClose}
        trackingName="AddToListFromOffcanvas"
      >
        {t("common:userlist.add_to_userlist")}
      </MenuListButton>
      <MenuListButton
        onClick={dislikeAndClose}
        trackingName="RemoveFromWishlistFromOffcanvas"
      >
        {t("common:userlist.remove_from_wishlist")}
      </MenuListButton>
    </div>
  );
}

export default withTranslation("common")(MenuWishlistProductEdit);
